import { Pipe, PipeTransform } from '@angular/core';
import { ITranslation } from '@routes/templates/models/template-model';

@Pipe({
    name: 'filterLanguage'
})
export class LanguagePipe implements PipeTransform {
    transform(contents: ITranslation[], language: string): string {
        if (contents) {
            return contents?.find(x => x.languageId === language)?.value;
        } else {
            return null;
        }
    }
}
